module.exports = __webpack_public_path__ + "static/media/oddparents2.b94da33f.gif";